import React from "react";
import * as Styled from "./NoTicketMessage.styled";
import TicketIcon from "../../../assets/images/icons/pencil.svg";
import { NoTicketMessageProps } from "../../../libs";

export const NoTicketMessage: React.FC<NoTicketMessageProps> = ({ onNewTicketClick }) => {
    return (
        <Styled.NoTicketContainer>
            <Styled.NoTicketCard>
                <Styled.NoTicketTitle>You have not submitted a support ticket</Styled.NoTicketTitle>
                <Styled.NoTicketDescription>
                    Write and address new queries and issues. The Cemboo support team is here to help you!
                </Styled.NoTicketDescription>
                <Styled.NewTicketButton onClick={onNewTicketClick}>
                    <Styled.Icon src={TicketIcon} alt="New Ticket" />
                    New Ticket
                </Styled.NewTicketButton>
            </Styled.NoTicketCard>
        </Styled.NoTicketContainer>
    );
};

